import React, { useRef, useEffect, useState } from "react";
import { Dialog, DialogContent, Typography, Stack } from "@mui/material";
import Lottie from "lottie-react";
import CheckAnimation from "../assets/animation/Animation - 1739687920759.json";

const ScanErrorDialog = ({ open, onClose, guestInfo }) => {
  const lottieRef = useRef(); // Lottieの参照を作成
  const [countdown, setCountdown] = useState(5); // カウントダウンの初期値を5に設定

  useEffect(() => {
    if (open) {
      setCountdown(6);

      // Lottieのアニメーションがロードされたら60フレーム目で停止
      const handleAnimationLoad = () => {
        if (lottieRef.current) {
          lottieRef.current.goToAndStop(60, true);
        }
      };

      // もしすでにLottieの参照がある場合は直接実行
      if (lottieRef.current) {
        handleAnimationLoad();
      }

      // カウントダウンを開始
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(countdownInterval);
            onClose(); // 0になったらダイアログを閉じる
            return 0;
          }
          return prev - 1;
        });
      }, 1000); // 1秒ごとにカウントダウン

      return () => {
        clearInterval(countdownInterval);
      };
    }
  }, [open, onClose]);

  if (!guestInfo) return null;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ pr: 10, pl: 10 }}>
        <Stack alignItems="center">
          <div style={{ width: 300, height: 300 }}>
            <Lottie
              lottieRef={lottieRef} // `ref` に渡す
              animationData={CheckAnimation}
              loop={false}
              autoPlay={false} // ここを false にすることで `goToAndPlay` が機能する
              onLoadedImages={() => {
                if (lottieRef.current) {
                  lottieRef.current.goToAndStop(60, true);
                }
              }}
            />
          </div>
        </Stack>

        <Stack spacing={4}>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Stack>
              <Typography variant="h4">{guestInfo.last_name}</Typography>
            </Stack>
            <Stack>
              <Typography variant="h4">{guestInfo.first_name}</Typography>
            </Stack>
            <Stack>
              <Typography variant="h4">様</Typography>
            </Stack>
          </Stack>

          <Stack alignItems="center" textAlign="center">
            <Typography variant="body1">
              ご参列いただき誠にありがとうございます
            </Typography>
            <Typography variant="body1">受付を完了しました</Typography>
          </Stack>

          {/* カウントダウンメッセージを表示 */}
          <Stack alignItems="center">
            <Typography variant="body1" color="textSecondary">
              <span style={{ fontSize: "1.5rem", color: "#000" }}>
                {countdown}
              </span>{" "}
              秒後に閉じられます
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ScanErrorDialog;
